import React, { memo, forwardRef } from "react";
const SvgDeterminantMatrix = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <rect width={6} height={9} x={5} y={5} fill="#DBDBDB" rx={1} />
      <rect width={6} height={9} x={21} y={5} fill="#DBDBDB" rx={1} />
      <rect width={6} height={9} x={13} y={5} fill="#DBDBDB" rx={1} />
      <rect width={6} height={9} x={21} y={18} fill="#DBDBDB" rx={1} />
      <rect width={6} height={9} x={13} y={18} fill="#DBDBDB" rx={1} />
      <rect width={6} height={9} x={5} y={18} fill="#DBDBDB" rx={1} />
      <path
        fill="#717171"
        d="M30.5 28.25a.75.75 0 001.5 0V3.966v-.178a.79.79 0 00-.804-.78c-.404.008-.696.33-.696.735V28.25zM.5 28.25a.75.75 0 001.5 0V3.966v-.178a.79.79 0 00-.804-.78c-.404.008-.696.33-.696.735V28.25z"
      />
    </svg>
  );
});
SvgDeterminantMatrix.displayName = "SvgDeterminantMatrix";
const MemoForwardRef = memo(SvgDeterminantMatrix);
export default MemoForwardRef;
